module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/invitations/invitations.component.scss
// module id = ./src/app/modules/invitations/invitations.component.scss
// module chunks = main